import { render, staticRenderFns, recyclableRender, components } from "./my-qualifications.vue?vue&type=template&id=65dc4eec&scoped=true&"
var renderjs
import script from "./my-qualifications.vue?vue&type=script&lang=js&"
export * from "./my-qualifications.vue?vue&type=script&lang=js&"
import style0 from "./my-qualifications.vue?vue&type=style&index=0&lang=css&"
import style1 from "./my-qualifications.vue?vue&type=style&index=1&id=65dc4eec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc4eec",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/my-qualifications/my-qualifications.vue"
export default component.exports